 <!-- footer section starts -->
<footer>
  <div class="footer">
    <div class="container">
      <div class="row">
        <!-- About Section -->
        <div class="col-md-4">
          <h5 class="heading f-heading">{{companysname}}</h5>
          <p>
            {{About}}
          </p>
          <div class="social hidden-xs footer-social mt-3">
            <a href="{{facebook}}" target="_blank" class="external facebook" data-animate-hover="pulse">
              <i class="fab fa-facebook"></i>
            </a>
            <a href="{{instagram}}" target="_blank" class="external instagram" data-animate-hover="pulse">
              <i class="fab fa-instagram"></i>
            </a>
            <a href="{{twitter}}" target="_blank" class="external twitter" data-animate-hover="pulse">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="{{linkedin}}" target="_blank" class="external linkedin" data-animate-hover="pulse">
              <i class="fab fa-linkedin"></i>
            </a>
          </div>
        </div>
        <!-- Quick Links -->
        <div class="col-md-2 footer-ul padding-lefty padding-ptt">
          <h5 class="heading f-heading">Quick Links</h5>
          <ul>
            <li><i class="fa fa-plane"></i><a class="showpointer" routerLink="/">Flights</a></li>
            <li><i class="fa fa-hotel"></i><a class="showpointer" routerLink="/hotel">Hotels</a></li>
            <li><i class="fa fa-umbrella-beach"></i><a class="showpointer" routerLink="/holiday">Holidays</a></li>
            <li><i class="fa-solid fa-van-shuttle"></i><a class="showpointer" routerLink="/transfer">Transfer</a></li>
            <li><i class="fa fa-binoculars"></i><a class="showpointer" routerLink="/sightseeing">Sightseeing</a></li>
          </ul>
          <img src="./assets/images/iataimg.png" alt="IATA Logo" width="60" style="margin-right:10px;"
               class="">
          <img src="./assets/images/IATO.png" alt="IATO Logo" style="width:35px;" class="">
        </div>
        <!-- Get in Touch -->
        <div class="col-md-3 footer-ul padding-ptt">
          <h5 class="heading f-heading">Get In Touch</h5>
          <ul>
            <li>
              <i class="fa-solid fa-location-dot"></i><a>
                {{Address}}
              </a>
            </li>
            <li><i class="fa-solid fa-envelope"></i><a href="#"> {{ContactEmail}}</a></li>
            <li><i class="fa-solid fa-phone"></i><a href="tel:{{ContactNo}}"> {{ContactNo}}</a></li>
          </ul>
        </div>
        <!-- Subscribe -->
        <div class="col-md-3 padding-ptt">
          <app-footer-subscribe></app-footer-subscribe>
        </div>
          <!--<div class="col-md-3 padding-ptt">
      <h5 class="heading f-heading">Subscribe</h5>
      <form>
        <div class="mb-3">
          <input type="text" class="form-control" placeholder="Name">
        </div>
        <div class="mb-3">
          <input type="email" class="form-control" placeholder="Email">
        </div>
        <button type="submit" class="btn btn-subscribe w-100">Subscribe</button>
      </form>
    </div>-->
        </div>
      </div>
    <div class="container footer-bottom foot-margin-home">
      <div class=" footer-links">
        <a class="copyrght">Copyright © {{currentYear}} {{companyfname}}. All rights reserved.</a>
        <div class="foot-right">
          <a class="btn btn-link showpointer" routerLink="/aboutus">About Us</a>
          <a routerLink="/Contactus" class="btn btn-link showpointer">Contact Us</a>
          <a class="btn btn-link showpointer" routerLink="/Faq">Help/FAQs</a>
          <a class="btn btn-link showpointer" routerLink="/Privacy-Policy">Privacy Policy</a>
          <a class="btn btn-link showpointer" routerLink="/Termandcondition">Terms Of Conditions</a>
          <a class="btn btn-link showpointer lastlink" routerLink="/Cancellation-policy">Cancellation Policy</a>
        </div>
      </div>
    </div>
  </div>
</footer>
<!-- End Of Footer Section  -->
